<template>
  <el-card class="new-site-unit" shadow="never">
    <div>
      <Uploader :list="imageData" multiple listType="picture" @upload-completed="addImageToUnit" @remove-upload="removeImage" @update-list="handleUpdate" />
    </div>
    <el-button style="margin-top: 12px;" @click="addUnit">Confirm Changes</el-button>
  </el-card>
</template>

<script>
import Uploader from './Uploader';

export default {
  name: 'EditUnitImages',
  components: { Uploader },
  data() {
    return {
      imageData: [],
    };
  },
  methods: {
    handleUpdate(list) {
      this.imageData = list.map((image) => ({
        url: image.response.url,
        createdBy: this.$keycloak.tokenParsed.email
      }));
    },
    addUnit() {
      // return complete unit since that gets displayed by parent component
      this.$emit('images-added', this.imageData);
    },
    addImageToUnit(url) {
      this.imageData.push({ url, createdBy: this.$keycloak.tokenParsed.email });
    },
    removeImage(url) {
      const updatedImages = this.imageData.map(document => document.url !== url);
      this.imageData = updatedImages;
    },
  },
};
</script>

<style scoped>
.tags {
  margin-top: 8px;
  height: 314px ;
}
.tag {
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditUnitImages.vue